import { useEffect } from 'react';
import useSWRImmutable from 'swr/immutable';

import {
    getDCProfessionalMappings,
    getDataCurProfessionalMappings,
} from '@/service/AnamnesisSectionAPI/ProfessionalAPI.js';

import { useProfessionalsStore } from '@/store.js';

const useProfessionalMappings = () => {
    const professionalMappings = useProfessionalsStore((state) => state.professionalMappings);
    const { data: dcResponse, isLoading: dcIsLoading } = useSWRImmutable(
        !professionalMappings ? 'dc-professional-mappings' : null,
        getDCProfessionalMappings
    );

    const { data: dataCurResponse, isLoading: dataCurIsLoading } = useSWRImmutable(
        !professionalMappings ? 'data-cur-professional-mappings' : null,
        getDataCurProfessionalMappings
    );

    useEffect(() => {
        if (
            dcIsLoading ||
            dataCurIsLoading ||
            professionalMappings ||
            !dcResponse?.data?.data ||
            !dataCurResponse?.data?.data
        ) {
            return;
        }

        const mergedResponse = [...dcResponse.data.data, ...dataCurResponse.data.data];

        const professionalMappingsObj = {};
        const professionalMappingsByIdObj = {};

        for (const mapping of mergedResponse) {
            if (mapping.prismic_key) professionalMappingsObj[mapping.prismic_key] = mapping;
            if (mapping.user_id) professionalMappingsByIdObj[mapping.user_id] = mapping;
        }

        useProfessionalsStore.setState({
            professionalMappings: professionalMappingsObj,
            professionalMappingsById: professionalMappingsByIdObj,
        });
    }, [dcIsLoading, dataCurIsLoading, dcResponse, dataCurResponse]);
};

export default useProfessionalMappings;
